import { useParams } from 'react-router-dom';
import {
  useCheckAccessToEdit,
  useGetCourse,
  useGetTAApplication,
} from '~/modules/applications/models/application.hooks';
import { CreateTAApplicationForm } from '~/modules/applications/components/CreateTAApplicationForm/CreateTAApplicationForm';
import { applicationTypes } from '~/modules/applications/models/application.model';

export const EditTAApplication = () => {
  const { applicationId, courseId } = useParams();
  const course = useGetCourse(courseId);
  const application = useGetTAApplication(applicationId);
  const formattedApplication = application && { ...application.data };
  useCheckAccessToEdit(applicationTypes.ta);
  if (formattedApplication) {
    Object.entries(formattedApplication).forEach(([key, value]) => {
      if (typeof value === 'number') {
        formattedApplication[key] = value.toString();
      }
    });
  }
  return (
    <div className="narrow mt-20">
      {course && application && (
        <CreateTAApplicationForm
          defaultValues={formattedApplication}
          course={course}
          isUpdate
          applicationId={applicationId}
        />
      )}
    </div>
  );
};
